/**
 * Tiny DOM helpers. We avoid a virtual-DOM framework on purpose -
 * the screen has a small surface area, and shipping a 50KB react bundle
 * down to a Chrome 56 / Tizen 4 device is exactly what we don't want.
 */

export interface ElementOpts {
  class?: string;
  text?: string;
  attrs?: Record<string, string | number | null | undefined>;
  dataset?: Record<string, string | number | null | undefined>;
  children?: (Node | null | false | undefined)[];
}

export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  opts: ElementOpts = {},
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  if (opts.class) el.className = opts.class;
  if (opts.text !== undefined) el.textContent = opts.text;
  if (opts.attrs) {
    for (const [key, value] of Object.entries(opts.attrs)) {
      if (value === null || value === undefined) continue;
      el.setAttribute(key, String(value));
    }
  }
  if (opts.dataset) {
    for (const [key, value] of Object.entries(opts.dataset)) {
      if (value === null || value === undefined) continue;
      el.dataset[key] = String(value);
    }
  }
  if (opts.children) {
    for (const child of opts.children) {
      if (child) el.appendChild(child);
    }
  }
  return el;
}

export function clear(el: HTMLElement): void {
  while (el.firstChild) el.removeChild(el.firstChild);
}
